import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-5" }
const _hoisted_2 = { class: "row gy-5 g-xl-10 gap-5 gap-xl-0" }
const _hoisted_3 = { class: "col-xl-9" }
const _hoisted_4 = { class: "row g-5 g-xl-10" }
const _hoisted_5 = { class: "col-xxl-12" }
const _hoisted_6 = { class: "card mb-5 mb-xl-10" }
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = { class: "card-title align-items-start flex-column" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar" }, null, -1)
const _hoisted_10 = { class: "card-body p-9" }
const _hoisted_11 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)
const _hoisted_13 = { class: "indicator-label" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 size" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "bi bi-sd-card-fill"
  })
], -1)
const _hoisted_15 = { class: "indicator-progress" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)
const _hoisted_17 = { class: "col-xl-3 mt-0 mt-xl-10" }
const _hoisted_18 = { class: "card shadow-sm mb-5 mb-xl-10" }
const _hoisted_19 = {
  class: "card-header collapsible cursor-pointer rotate",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_docs_card_customer_information"
}
const _hoisted_20 = { class: "card-title flex-fill align-items-start flex-column" }
const _hoisted_21 = { class: "card-toolbar rotate-180" }
const _hoisted_22 = { class: "svg-icon svg-icon-1" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  id: "kt_docs_card_customer_information",
  class: "collapse show"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "fs-6 d-flex flex-column gap-5" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form = _resolveComponent("el-form")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_form, {
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
              rules: _ctx.rules,
              model: _ctx.formData,
              ref: "formRef"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("h2", null, _toDisplayString(_ctx.t("salesOrder.distribution")), 1)
                    ]),
                    _hoisted_9
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_10, null, 512), [
                    [_directive_loading, _ctx.loading]
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-secondary align-self-center me-2",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
                    }, [
                      _hoisted_12,
                      _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
                    ]),
                    _createElementVNode("button", {
                      type: "submit",
                      ref: _ctx.submitButton,
                      class: "btn btn-primary"
                    }, [
                      _createElementVNode("span", _hoisted_13, [
                        _hoisted_14,
                        _createTextVNode(" " + _toDisplayString(_ctx.t("common.saveChanges")), 1)
                      ]),
                      _createElementVNode("span", _hoisted_15, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_16
                      ])
                    ], 512)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["rules", "model"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.t("salesOrder.customerInformation")), 1)
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("span", _hoisted_22, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr072.svg" })
              ])
            ])
          ]),
          _hoisted_23
        ])
      ])
    ])
  ]))
}